.badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 999px;
    font-family: Hanken Grotesk;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    border: 1px solid transparent;
}

.icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

// Neutral grey — no work started yet.
.notStarted {
    background-color: #f2f4f7;
    color: #667085;
    border-color: #e4e7ec;
}

// In-progress — modules being run.
.running {
    background-color: #ffffff;
    color: #344054;
    border-color: #d0d5dd;
}

// All modules complete.
.completed {
    background-color: #ffffff;
    color: #344054;
    border-color: #d0d5dd;
}

// Narrative generated — furthest stage.
.narrative {
    background-color: #ffffff;
    color: #102442;
    border-color: #d0d5dd;
    font-weight: 600;
}
